export const tabandmo = "@media (max-width: 768px)";
